import { Box, LinearProgress } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"
import React from "react"

import type { Location } from "@/graphql/codegen/graphql"
import { COMPANY_EDIT_ROUTE } from "@/screens/Companies/constants"
import ContactsInfo from "@/screens/Companies/edit/components/locations/components/ContactsInfo"
import LocationContactMethods from "@/screens/Companies/edit/components/locations/components/LocationContactMethods"
import Notes from "@/screens/Companies/edit/components/locations/components/Notes"
import { LocationMenuDialogs } from "@/screens/Companies/edit/components/locations/types/dialogs"
import { useLocation } from "@/screens/Contacts/edit/hooks/useLocation"

interface VirtualRowProps<Location> {
  row: Row<Location>
  setDialogOpened: (dialog: LocationMenuDialogs | null) => void
  setActiveEditLocation: (location: Location) => void
}

const ExpandedLocationRow = ({
  row,
  setActiveEditLocation,
  setDialogOpened,
}: VirtualRowProps<Location>): ReactElement => {
  const { companyId: queryCompanyId } = useParams({ from: COMPANY_EDIT_ROUTE })
  const { locationId, phoneNumber, altPhoneNumber, faxNumber, notes } = row.original

  const { locationDetailsData, locationDetailsFetching, reexecuteLocationDetailsQuery } = useLocation(locationId)

  const handleEditLocationContactMethods = () => {
    setActiveEditLocation(row.original)
    setDialogOpened(LocationMenuDialogs.EDIT_CONTACT)
  }

  return (
    <Box className='flex flex-col'>
      {locationDetailsFetching ? (
        <LinearProgress />
      ) : (
        <>
          <LocationContactMethods
            phoneNumber={phoneNumber}
            altPhoneNumber={altPhoneNumber}
            faxNumber={faxNumber}
            handleEditLocationContactMethods={handleEditLocationContactMethods}
          />
          <ContactsInfo
            companyId={queryCompanyId}
            locationData={locationDetailsData}
            onRefreshData={reexecuteLocationDetailsQuery}
          />
          <Notes originalNotes={notes} locationId={locationId} />
        </>
      )}
    </Box>
  )
}

export default ExpandedLocationRow
